module.exports = __webpack_public_path__ + "img/logo.877543ce.svg";